// extracted by mini-css-extract-plugin
export default {"characteristicsBlock":"CharacteristicsBlock_characteristicsBlock__w81Fu"};